import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { Button } from '@shipt/design-system-buttons'
import { Row } from '@shipt/design-system-layouts'

export const CMSFormInputWrapper = styled(Row)`
  @media ${screenSizes.max_mobile} {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
`

export const CMSInputWrapper = styled.div`
  width: 100%;

  @media ${screenSizes.tablet} {
    max-width: 14.6875rem;
    flex: 1 0;
  }
`

export const CMSFormSubmitButton = styled(Button)`
  max-height: 3rem;
  margin-bottom: 1rem;

  @media ${screenSizes.max_mobile} {
    width: 100%;
    max-width: 100%;
  }
`
